export default {"src":"/_next/static/image/public/images/ic_info_blue.945b9e92f510b35873e9bb0c4492b948.svg","height":20,"width":20};